<template>
  <card class="card-stats">
    <div class="statistics statistics-horizontal">
      <div class="info info-horizontal">
        <div v-if="appointment.referenceId" class="row appointment-id justify-content-end pr-4">
          <div class="" style="font-size: small; font-weight: 600;">
            <span style="margin-right: 0.5em">
              <i class="fas fa-hashtag"></i>
            </span>
            <span>{{ appointment.referenceId }}</span>
          </div>
        </div>
        <div class="row visit-details details">
          <div class="col-3 col-md-4 pr-0">
            <div class="row">
              <div class="col-12 text-center">
                <img :src="avatarImage" class="picture-src" style="width:100px; border-radius: 50%; outline-color: transparent;" />
                <br />
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <div v-if="appointment.patient.gender == 'male'" style="color:rgb(33, 150, 243);">
                  <span>
                    <i class="fa fa-mars"></i>
                  </span>
                </div>
                <div v-if="appointment.patient.gender == 'female'" style="color:rgb(235, 63, 157);">
                  <span>
                    <i class="fa fa-venus"></i>
                  </span>
                </div>
                <div v-if="appointment.patient.gender == 'others'" style="color:rgb(33, 243, 208);">
                  <span>
                    <i class="fa fa-transgender-alt"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-9 col-md-8 right">
            <slot>
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-user"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{appointment.patient.firstName}} {{ appointment.patient.lastName }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-info-circle"></i>
                  </span>
                </div>
                <div class="col-md-10 col-9 pl-0">
                  <span>{{appointment.patient.patientId}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-birthday-cake"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{ getAge(appointment.patient.dob)}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-mobile"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{appointment.patient.mobileNumber}}</span>
                </div>
              </div>
              <div class="row" v-if="appointment.appointmentType=='Scheduled'">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-clock-o"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{getAppointmentDatetime(appointment.scheduledTimestamp.start)}}</span>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <div class="stats text-center" slot="footer">
      <n-button type="primary" class="btn-padding light mr-2" round @click.native="declineVisit(appointment)">
        <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
        {{ $t('message.Decline') }}
      </n-button>
      <n-button type="primary" class="btn-padding light mr-2" round @click.native="attend(appointment)">
        <i slot="label" class="now-ui-icons arrows-1_minimal-right"></i>
        {{ $t('message.Attend') }}
      </n-button>
    </div>
  </card>
</template>

<script>
import avatarImage from "@/assets/img/proAvatar.png";
import moment from "moment-timezone";
import socket from "@/services/socket";

export default {
  name: "appointment-request-card",

  data() {
    return {
      avatarImage,
      loader: null,
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },

  props: ["appointment"],

  methods: {
    getFormattedDob(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getAppointmentDatetime(timestamp) {
      return moment(Number(timestamp)).format("hh:mm a");
    },

    async attend(appt) {
      //Check if no other care coordinator has responded for the request
      try {
        await this.$store.dispatch("validateAppointmentRequest", appt._id);

        //If this care coordinator has already responded, don't update anything again
        if (!appt.careCoordinator.id) {
          //Update status of request to UnderReview
          appt.latestStatus = "UnderReview";
          appt.appointmentStatus.push({
            status: "UnderReview",
            timestamp: new Date().getTime(),
          });

          //Update care coordinator details
          appt.careCoordinator.id = this.user._id;
          appt.careCoordinator.firstName = this.user.firstName;
          appt.careCoordinator.lastName = this.user.lastName;
          appt.careCoordinator.username = this.user.username;

          //Update appointment with changes
          appt = await this.$store.dispatch("updateAppointment", appt);
        }

        this.$store.commit("setState", {
          stateName: "appointment",
          stateValue: appt,
        });
        this.$router.push("attendrequest");

        socket.emit("appointmentRequestAttended", appt._id);
      } catch (e) {
        if (
          e.response &&
          e.response.data &&
          e.response.data.message ==
            "Appointment is being reviewed by another care-cordinator"
        ) {
          swal
            .fire({
              type: "info",
              title: this.$t("message.This request has been responded by another Care Coordinator"),
              timer: 2000,
            })
            .then(() => {
              alert();
              this.$emit("appointment-declined");
            });
        }
        console.log(e);
      }
    },
    declineVisit(appointment) {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          text: this.$t("message.You will not be able to take this appointment later!"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: this.$t("message.Yes, decline it!"),
          closeOnConfirm: true,
        })
        .then(async (isConfirm) => {
          if (isConfirm) {
            this.loader = this.$loading.show({
              container: null,
              canCancel: false,
            });

            try {
              await this.$store.dispatch("updateStatus", {
                appointmentId: appointment._id,
                status: "Declined",
              });

              socket.emit("appointmentDeclined", {
                appointmentId: appointment._id,
              });

              try {
                let patient = await this.$store.dispatch(
                  "getPatientByPatientId",
                  appointment.patient.patientId
                );

                socket.emit("appointmentDeclined", {
                  patientId: patient._id,
                  apptId: appointment._id,
                });
              } catch (e) {
                console.log(e);
              }

              this.$emit("appointment-declined");
              this.loader.hide();
            } catch (e) {
              this.loader.hide();
              console.log(e);
            }
          }
        });
    },
  },
};
</script>

<style>
</style>
